import React from 'react';
import PropTypes from 'prop-types';
import RightHandLinkButton from '@Components/Results/right-hand-link-button.component.jsx';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import ReactTargetHelper from '@Components/Results/services/react-target-helper.service';
import uuid from 'uuid/v4';

export default class TargetRightHandLinksComponent extends React.PureComponent {

  constructor(props) {
    super(props);

    this.openElementLink = this.openElementLink.bind(this);
  }

  openElementLink(type) {
    const { metadata } = this.props;

    const requestParams = {
      hitSetKey: metadata.hitSetKey,
      resultName: metadata.resultName,
      searchId: metadata.searchId || uuid(), // results or preview
    };

    if (metadata.order) {
      requestParams.order = metadata.order;
    }

    ReactTargetHelper.openElementLink(type, this.props.target, requestParams);
  }

  getTrackingAttrs() {
    return {
      ...this.props.trackingAttrs,
      'data-tracking': !this.props.detailsExpanded,
      'data-tracking-type': 'contentview,contentlinkclick',
      'data-tracking-action': 'target details',
    };
  }

  render() {
    const { target } = this.props;

    return (
      <div className='target-details-right els-btn-group-vertical'>
        {target.substancesCount > 0 && (
          <RightHandLinkButton
            openElementLink={this.openElementLink}
            dataLinkType='substances'
            text={`Substances - ${target.substancesCount}`}
            type='link'
            iconPosition='right'
            size='sm'
            icon='chevron-right'
          />
        )}
        {target.documentsCount > 0 && (
          <RightHandLinkButton
            openElementLink={this.openElementLink}
            dataLinkType='documents'
            text={`Documents - ${target.documentsCount}`}
            type='link'
            iconPosition='right'
            size='sm'
            icon='chevron-right'
          />
        )}
      </div>
    );
  }
}

TargetRightHandLinksComponent.propTypes = {
  metadata: MetadataPropTypesShape,
  target: PropTypes.object.isRequired,
};
